'use client'

import { TeamCard } from './TeamCard'
import type { Team } from '@/lib/api/teams'

interface TeamGridProps {
  teams: Team[]
}

export function TeamGrid({ teams }: TeamGridProps) {
  if (teams.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="text-6xl mb-4">📭</div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">暂无相关团队</h3>
        <p className="text-sm text-gray-500">请尝试调整筛选条件</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {teams.map(team => (
        <TeamCard key={team.id} data={team} />
      ))}
    </div>
  )
}
